let msaDeviceTicket: string | null = null;

export function getMsaDeviceTicket(): string | null {
    return msaDeviceTicket;
}

export function setMsaDeviceTicket(ticket: string): void {
    if (ticket && ticket !== msaDeviceTicket) {
        msaDeviceTicket = ticket;
    }
}
